import { Box, SvgIconProps } from '@mui/material';
import { SportsType } from '../../@types';
import { getMinioUrl } from '../../utils/urlUtils';
import { mergeSx } from '../../utils/styles';
import { getSportIconUrl, usesSportIconMask } from '../../utils/sportIcons';
import { useMarketplaceConfig } from '../../queries/marketplace';

type SportsIconProps = {
  name: SportsType;
  size?: number | string;
  sx?: SvgIconProps['sx'];
};

const SportsIcon = ({ name, size, sx }: SportsIconProps) => {
  const { data: marketplaceConfig } = useMarketplaceConfig();
  const sportIconsVariant = marketplaceConfig?.sportsbookConfig?.assetVariants?.sportIcons;
  const minioBaseUrl = getMinioUrl();

  if (!minioBaseUrl || !name) {
    return null;
  }

  const iconUrl = getSportIconUrl({ minioBaseUrl, name, variant: sportIconsVariant });
  const defaultSizeStyle = size ? { width: size, height: size } : { width: 'initial', height: 'initial' };

  if (usesSportIconMask(sportIconsVariant)) {
    return (
      <Box
        role='img'
        aria-label={name}
        sx={mergeSx(
          defaultSizeStyle,
          {
            display: 'inline-block',
            flexShrink: 0,
            aspectRatio: '1',
            backgroundColor: 'currentColor',
            maskImage: `url(${iconUrl})`,
            maskPosition: 'center',
            maskSize: 'contain',
            maskRepeat: 'no-repeat',
            WebkitMaskImage: `url(${iconUrl})`,
            WebkitMaskPosition: 'center',
            WebkitMaskSize: 'contain',
            WebkitMaskRepeat: 'no-repeat',
          },
          sx
        )}
      />
    );
  }

  return (
    <Box
      component='img'
      src={iconUrl}
      alt={name}
      sx={mergeSx(defaultSizeStyle, sx)}
      onError={(e) => {
        if (e.currentTarget) {
          e.currentTarget.style.display = 'none';
        }
      }}
    />
  );
};

export default SportsIcon;
